/* eslint-disable linebreak-style */
/* eslint-disable react/jsx-filename-extension */
/* eslint-disable import/extensions */
import React, { useEffect } from 'react';
import Header from 'parts/Header';
import Footer from 'parts/Footer';
import { Fade } from 'react-awesome-reveal';
import Button from 'elements/Button';
import { Products } from 'json/landingPageData';

export default function ProductsPage() {
  useEffect(() => { window.scrollTo(0, 0); }, []);
  return (
    <>
      <Header />
      <section className="container mx-auto">
        <Fade bottom>
          <h1 className="text-5xl text-theme-blue text-center font-bold mt-10">Products</h1>
          <p className="font-light text-lg text-gray-400 text-center mb-12">Explore our packaged solutions ready to deploy.</p>
        </Fade>
        <div className="grid grid-cols-2 sm:grid-cols-3 sm:gap-2 xl:gap-8 items-stretch justify-items-center">
          {Products.map((item, index) => (
            <Fade direction="up" triggerOnce delay={300 * index} key={item.id}>
              <Button type="link" href={`/product/${item.id}`}>
                <div className="group rounded-2xl shadow-xl w-full h-full m-3 transform-gpu will-change-transform transition duration-300 md:hover:-translate-y-1 portofolio-card flex flex-col">
                  <div className="relative flex items-center justify-center bg-white">
                    <img
                      src={item.imageUrl}
                      alt={item.title}
                      className="rounded-t-2xl z-0 max-w-full h-auto object-contain"
                      onError={(e) => { e.currentTarget.onerror = null; e.currentTarget.src = 'https://images.unsplash.com/photo-1520975922172-3d1c19b7b1d5?auto=format&fit=crop&w=1400&q=60'; }}
                    />
                  </div>
                  <div className="py-4 mt-auto min-h-20">
                    <h2 className="text-theme-blue text-center text-xl">{item.title}</h2>
                    <p className="font-light text-gray-400 text-center">{item.type}</p>
                  </div>
                </div>
              </Button>
            </Fade>
          ))}
        </div>
      </section>
      <Footer />
    </>
  );
}
